<template>
    <div class="order-wrapper">
        <div class="container">
            <h1 class="order-title">
                {{ $t('buy_subscription') }}: {{ subscription.subscription }}
                <span v-if="timetable">{{ $t('to_group') }} {{timetable.name}}</span>
            </h1>

            <div>
                <div class="ui-steeps mb-6">
                    <ul class="ui-steeps__header">
                        <li class="ui-steep-header-item is-active">
                            <div class="ui-steep-header-item__text">
                                1. {{ $t('order') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                2. {{ $t('payment') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                <span class="d-none d-sm-block">3. {{ $t('payment_information') }}</span>
                                <span class="d-block d-sm-none">3. {{ $t('abput_payment') }}</span>
                            </div>
                        </li>
                    </ul>
                </div><!-- /.ui-steeps -->


                <div class="row justify-content-center mb-5">
                    <div class="col-12 col-lg-5">
                        <SubscriptionItem
                                :subscription="subscription"
                                :active="true"
                                :hideOrderButton="true"
                                :showRecurrentParam="subscription.price > 0"
                                @recurrentParamUpdate="(v) => recurrentParam=v"
                        />
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div
                            v-if="assigned && !subscription.studyProducts"
                            class="col-12 col-lg-6 text-center mb-4 mt--4 mx-2"
                    >
                        {{ $t('your_already_have_subscription_for_') }} <span v-if="!timetable">{{ $t('_for_individual_') }} </span>
                        {{ $t('_lessons_') }}<span v-if="timetable"> {{ $t('_in_group_') }} <span
                            class="strong-black">{{ timetable.description }}</span></span>.
                        {{ $t('new_subscription_starts_') }}<span class="strong-red" v-if="subscriptionStartDate"> {{ $t('with') }}&nbsp;{{ subscriptionStartDate }}</span>,
                        {{ $t('_after_expiring_existing') }}
                    </div>
                </div>

                <h2 class="order-subtitle mt-2">
                    {{ $t('please_fill_out_the_form') }}
                </h2>

                <div v-if="error">
                    <base-alert type="danger">{{error}}</base-alert>
                </div>

                <div class="row justify-content-center">
                    <div class="col-sm-6 col-md-4" v-if="!user.email">
                        <label class="order-form__label" for="name">Email</label>
                        <base-input alternative=""
                                    :error="fieldError('email')"
                                    id="email"
                                    class="order-form__control"
                                    :placeholder="`${$t('enter_your_email')}*`"
                                    v-model="email"
                                    @input="setEdited"
                        />
                        <div v-if="!user.email && !isAuthenticated() && existingEmail">
                            <base-alert type="danger">
                                {{ $t('email_already_exists_') }}
                                <router-link
                                        :to="`/user/signin?return=` + returnUrl() + `&login=` + encodeURIComponent(existingEmail)"
                                        class="conrifm-email-order">{{ $t('login_now') }}</router-link>
                                {{ $t('_login_or_enter_another_email') }}
                            </base-alert>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <label class="order-form__label" for="name">{{ $t('name') }}</label>
                        <base-input alternative=""
                                    :error="fieldError('name')"
                                    id="name"
                                    class="order-form__control"
                                    :placeholder="$t('enter_your_name')"
                                    v-model="profile.name"
                                    @input="setEdited"
                        />
                    </div>

                    <div class="col-sm-6 col-md-4">
                        <label class="order-form__label" for="name">{{ $t('phone') }}</label>
                        <base-input alternative=""
                                    :error="fieldError('phone')"
                                    id="phone"
                                    class="order-form__control"
                                    :placeholder="$t('enter_your_phone')"
                                    v-model="profile.phone"
                                    @input="setEdited"
                        />
                        <div v-if="!isAuthenticated() && existingPhone">
                            <base-alert type="danger">
                                {{ $t('phone_already_exists_') }}
                                <router-link
                                        :to="`/user/signin?return=` + returnUrl() + `&login=` + encodeURIComponent(existingPhone)"
                                        class="conrifm-email-order">{{ $t('login_now') }}</router-link>
                                {{ $t('_login_or_enter_another_phone') }}
                            </base-alert>
                        </div>
                    </div>

                    <div :class="['col-sm-6', user.email ? 'col-md-4' : 'col-md-9']">
                        <label class="order-form__label" for="name">{{ $t('comment') }}</label>
                        <base-input alternative=""
                                    id="comment"
                                    class="order-form__control"
                                    :placeholder="$t('comment_to_order')"
                                    v-model="comment"
                                    @input="setEdited"
                        />
                    </div>

                    <div class="w-100"></div>

                    <!--
                    <div class="col-sm-6 col-md-3">
                        <label class="order-form__label" for="country">Страна</label>
                        <select class="form-control order-form__control" name="country" id="country" v-model="country"
                                @change="setEdited">
                            <option :value="null">Выберите страну</option>
                            <option v-for="(item, index) in countries" :key="index">{{item.name}}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <label class="order-form__label" for="region">Регион</label>
                        <select class="form-control order-form__control" name="region" id="region" v-model="region"
                                @change="setEdited">
                            <option :value="null">Выберите регион</option>
                            <option v-for="(item, index) in regions" :key="index">{{item.name}}</option>
                        </select>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <label class="order-form__label" for="city">Город</label>
                        <select class="form-control order-form__control" name="city" id="city" v-model="profile.city"
                                @change="setEdited">
                            <option :value="null">Выберите город</option>
                            <option v-for="(item, index) in cities" :key="index">{{item.name}}</option>
                        </select>
                    </div>
                    -->
                </div><!-- /.row -->

                <div class="row">
                    <div class="col-sm-6 col-md-3 offset-md-3">
                        <base-input :placeholder="$t('use_promocode')" v-model="promocode"/>
                    </div>

                    <div class="col-sm-6 col-md-3 zapis">
                        <base-button
                                :data-id="subscription.idsubscription"
                                data-model="subscription"
                                :data-price="subscription.price"
                                data-action="gotoPayment"
                                :data-label="subscription.price == 0 ? $t('get_free') : $t('go_to_payment')"
                                type="primary"
                                class="btn-block"
                                :disabled="disablePayButton || error"
                                @click="gotoPayment"
                        >
                            {{ subscription.price == 0 ? $t('get_free') : $t('go_to_payment') }}
                            <i class="fa fa-arrow-right ml-2"></i>
                        </base-button>
                    </div>
                </div><!-- /.row -->
            </div>
        </div>
        <modal
            :show="emailConfirmDialog"
            @close="emailConfirm"
        >
          <template v-slot:header v-if="timetable">
            <h2>{{ $t('confirm_email_address') }}</h2>
          </template>
          <p>Чтобы зарегистрироваться на занятия, пожалуйста заполните e-mail в профиле. Без указания адреса электронной почты участие в online-занятиях невозможно.</p>
          <template v-slot:footer>
            <base-button
                type="primary" @click="emailConfirm">
              {{ $t('accepting_email') }}
            </base-button>
          </template>
        </modal>
    </div>
</template>

<script>
    import JwtService, {isAuthenticated} from "../../data/jwt.service";
    import userApi from "../../data/UserApi";
    import axios from 'axios'
    import SubscriptionItem from "./SubscriptionItem";
    import subscriprionApi from "../../data/SubscriptionApi";
    import timetableApi from "../../data/TimetablesApi";
    import CStorage from "../../data/CStorage";
    import moment from 'moment';

    export default {
        name: 'order',
        props: ['id', 'timetableId'],
        components: {
            SubscriptionItem,
        },
        data() {
            return {
                user: {email: null},
                profile: {name: null, phone: null, city: null, country: null},
                editProfile: false,
                subscription: {},
                country: null,
                region: null,
                countries: [],
                regions: [],
                cities: [],
                promocode: '',

                error: null,
                fieldsErrors: [],
                loading: false,
                assigned: false,
                disablePayButton: false,

                timetable: null,
                phone: null,
                comment: null,

                recurrentParam: true,

                lastActiveSubscription: null,
                email: null,

                existingEmail: null,
                existingPhone: null,

                emailConfirmDialog: false
            }
        },

        computed: {
            subscriptionStartDate() {
                if (this.lastActiveSubscription) {
                    return moment(this.lastActiveSubscription.end_date).add(1, 'days').format('DD\u00A0MMMM\u00A0YYYY')
                }
                return null
            },
        },
        watch: {
            country: async function (val) {
                const countryItem = this.getBy('name', val, this.countries)
                if (!countryItem.hasOwnProperty('id')) return []
                const response = await axios({method: 'get', url: '/regions?filter[country_id]=' + countryItem.id})
                this.regions = response.data
                this.profile.country = val
            },
            region: async function (val) {
                const regionItem = this.getBy('name', val, this.regions)
                if (!regionItem.id) return []
                const response = await axios({method: 'get', url: '/cities?filter[region_id]=' + regionItem.id})
                this.cities = response.data
                //this.profile.region = val
            },
        },
        async mounted() {
            moment.locale(this.$i18n.locale)

            let resp = await axios({method: 'get', url: '/countries'})
            this.countries = resp.data
            subscriprionApi.fetchSubscription(this.id)
                .then(async response => {
                    this.subscription = response
                    if (this.subscription.stype === 'OnlineTeacher Group') {
                        if (this.timetableId) {
                            timetableApi.fetchTimetable(this.timetableId)
                                .then(async response => {
                                    this.timetable = response
                                })
                                .catch(error => {
                                    let data = (error && error.response) ? error.response.data : {}
                                    this.error = this.pretty(data)
                                    this.loading = false
                                })
                        } else {
                            this.error = this.$t('error_missing_timetable_id')
                        }
                    } else if ((this.subscription.stype === 'OnlineTeacher Individual' || this.subscription.stype === 'OnlineTeacher Complex Individual') && this.timetableId) {
                        this.error = this.$t('error_timetable_id_unnecessarily')
                    }

                })
                .catch(error => {
                    let data = (error && error.response) ? error.response.data : {}
                    this.error = this.pretty(data)
                    this.loading = false
                })

            if (!isAuthenticated()) {
                this.user = {}
                this.profile = {}
            } else {
                this.fetchProfile()
            }

        },

        methods: {
            fetchProfile() {
                userApi.fetchCRMProfile()
                    .then(async response => {
                        this.user = response
                        if (!this.user.email)
                          this.emailConfirmDialog = true
                        this.profile = Object.assign({}, this.user.profile)
                        if (!this.profile.phone && this.user.phone)
                            this.profile.phone = this.user.phone
                        let resp = await axios({method: 'get', url: '/countries'})
                        this.countries = resp.data
                        if (!this.profile.country) {
                            this.profile.country = this.$t('default_country')
                            this.setEdited()
                        }
                        this.country = this.profile.country
                        this.cities = [{name: this.profile.city}]

                        if (this.timetableId) {
                            this.assigned = this.user.timetablesIdsWithActiveSubscriptions.includes(Number(this.timetableId))
                            if (this.assigned) {
                                userApi.fetchLastActiveCRMSubscription(this.timetableId)
                                    .then(async response => {
                                        this.lastActiveSubscription = response
                                    })
                                    .catch(error => {
                                        let data = (error && error.response) ? error.response.data : {}
                                        this.error = this.pretty(data)
                                        this.loading = false
                                    })
                            }
                        } else {
                            if (this.user.individualTimetableId) {
                                this.assigned = this.user.individualTimetableId
                                userApi.fetchLastActiveCRMSubscription(this.user.individualTimetableId)
                                    .then(async response => {
                                        this.lastActiveSubscription = response
                                    })
                                    .catch(error => {
                                        let data = (error && error.response) ? error.response.data : {}
                                        this.error = this.pretty(data)
                                        this.loading = false
                                    })
                            }
                        }
                    })
                    .catch(error => {
                        let data = (error && error.response) ? error.response.data : {}
                        this.error = this.pretty(data)
                        this.loading = false
                    })
            },

            async submitProfileChange() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                this.editProfile = false
                try {
                    this.user.profile = await userApi.updateProfileAsync(this.profile)
                    this.profile = Object.assign({}, this.user.profile)
                    JwtService.saveUser(this.user)
                    this.loading = false
                } catch (error) {
                    this.editProfile = true
                    let data = error.response.data
                    if (error.response.status === 422) {
                        this.fieldsErrors = data
                    } else if (error.response.status === 401) {
                        this.error = this.$t('error_401')
                    } else {
                        this.error = this.pretty(data)
                    }
                    this.loading = false
                }
            },

            setEdited(v) {
                this.editProfile = true
                // console.log('profile edited: ' + v)
            },

            async gotoPayment() {
                this.fieldsErrors = []
                let hasErrors = false
                this.existingEmail = null


                if (!isAuthenticated()) {
                    if (!this.email) {
                        hasErrors = true
                        this.fieldsErrors.push({
                            field: 'email',
                            message: this.$t('fill_in_email'),
                        })
                    }

                    if (!this.profile.name) {
                        hasErrors = true
                        this.fieldsErrors.push({
                            field: 'name',
                            message: this.$t('fill_in_name'),
                        })
                    }
                }
                if (!this.profile.phone) {
                    hasErrors = true
                    this.fieldsErrors.push({
                        field: 'phone',
                        message: this.$t('fill_in_phone'),
                    })
                }
                if (hasErrors) return

                if (!isAuthenticated()) {
                    // если пользователь не зарегистрирован ранее, то регистрируем его указанным e-mail
                    // если пользователь с таким e-mail уже существует, то отправлем его на форму логина
                    try {
                        this.user = await userApi.orderRegistration(this.profile.name, this.email, this.profile.phone)
                        console.log('user', this.user)
                        JwtService.saveUser(this.user)
                        userApi.pushUserContext()
                    } catch (error) {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                            //Если пользователь с таким e-mail уже существует, отправляем его на форму логина
                            this.fieldsErrors.filter(field => {
                                if (field.code === 'emailExists') this.existingEmail = this.email
                                if (field.code === 'phoneExists') this.existingPhone = this.profile.phone

                            })
                        } else {
                            this.error = this.pretty(data)
                        }
                        return
                    }
                }

                if (isAuthenticated()) {
                    userApi.utm()
                    this.disablePayButton = true
                    if (this.editProfile) {
                        this.profile.user_id = this.user.id
                        await this.submitProfileChange()
                    }

                    let cid = ''
                    if (this.$metrika && this.$metrika.getClientID()) cid = btoa(this.$metrika.getClientID())

                    CStorage.setItem('ORD_SUB_phone', this.phone)
                    CStorage.setItem('ORD_SUB_comment', this.comment)

                    if (parseInt(this.subscription.price) === 0) {
                        if (this.subscription.stype === 'OnlineTeacher Group' && this.timetableId) {
                            const params = new URLSearchParams({
                                'idsubscription': this.subscription.idsubscription,
                                'timetableId': this.timetableId,
                                'cid': cid,
                            })
                            try {
                                await axios({url: '/payment/freesubscription?' + params.toString()})
                                this.$router.push('/paymentstatus/free?' + params.toString())
                            } catch (error) {
                                let data = (error && error.response) ? error.response.data : {}
                                this.error = this.pretty(data)
                                this.loading = false
                            }
                        } else if ((this.subscription.stype === 'OnlineTeacher Individual' || this.subscription.stype === 'OnlineTeacher Complex Individual') && !this.timetableId) {
                            const params = new URLSearchParams({
                                'idsubscription': this.subscription.idsubscription,
                                'cid': cid,
                            })
                            try {
                                await axios({url: '/payment/freesubscription?' + params.toString()})
                                this.$router.push('/paymentstatus/free?' + params.toString())
                            } catch (error) {
                                let data = (error && error.response) ? error.response.data : {}
                                this.error = this.pretty(data)
                                this.loading = false
                            }
                        } else {
                            this.error = this.$t('error_missing_or_wrong_timetable_id')
                        }
                    } else {
                        let params = []
                        if (this.promocode) params.push('promocode=' + this.promocode)
                        if (this.recurrentParam) params.push('recurrent=true')
                        if (this.timetableId) {
                            this.$router.push('/subscription/payment/' + this.subscription.idsubscription + '/' + this.timetableId + (params.length ? ('?' + params.join('&')) : ''))
                        } else {
                            this.$router.push('/subscription/payment/' + this.subscription.idsubscription + (params.length ? ('?' + params.join('&')) : ''))
                        }
                    }
                }
            },

            emailConfirm() {
              this.$router.push('/user/profile/email?return=' + this.$route.path)
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },


            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },

            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            isAuthenticated() {
                return isAuthenticated()
            },

            returnUrl() {
                return window.location.pathname.replace(process.env.VUE_APP_PUBLIC_PATH, '/')
            }
        }
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
